import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Box } from '@mui/material'
import TextShadow from 'components/Text/TextShadow'
import HoverButtton from 'components/Button/HoverButton'

const useStyles = makeStyles((theme) => ({
  gameBannerContainer: {
    backgroundColor: '#FFC6A8',
    padding: '8px',
    position: 'relative',
    zIndex: 11,
    margin: '0 0 40px',
    borderRadius: '8px',
  },
  gameBanner: {
    backgroundColor: '#FFDFBA',
    padding: '16px 32px',
    borderRadius: '8px',
    position: 'relative',
    fontFamily: "'Dosis', sans-serif",
    '& .spinCover': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '256px',
      height: '256px',
      position: 'relative',
      margin: '0 auto',
    },
    '& .spinBG': {
      width: '256px',
      height: '256px',
      backgroundImage: "url('/images/wheel.png')",
      animationName: 'animate__spin__back',
      animationDuration: '700ms',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    '& .smoyPin': { position: 'relative', zIndex: 12, width: 56 },
    '& .smoyBG': {
      position: 'absolute',
      bottom: 0,
      right: 0,
      width: '72px',
      height: '72px',
    },
    '& .bannerContent': {
      margin: '16px 0 0',
      textAlign: 'center',
      '& span': {
        fontWeight: 800,
      },
      '& p': {
        fontSize: '18px',
        lineHeight: '24px',
        color: '#2B1C2F',
        margin: '4px 0',
        fontWeight: 800,
      },
      '& button > span > span': {
        display: 'flex',
        alignItems: 'center',
      },
    },
  },
  [theme.breakpoints.up('sm')]: {
    gameBannerContainer: {
      backgroundColor: '#FFC6A8',
      padding: '8px',
      position: 'relative',
      zIndex: 11,
      margin: '0 0 40px',
    },
    gameBanner: {
      backgroundColor: '#FFDFBA',
      padding: '16px 32px',
      borderRadius: '8px',
      position: 'relative',
      fontFamily: "'Dosis', sans-serif",
      '& .spinCover': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '256px',
        height: '256px',
        position: 'relative',
        margin: '0 auto',
      },
      '& .spinBG': {
        width: '256px',
        height: '256px',
        backgroundImage: "url('/images/wheel.png')",
        animationName: 'animate__spin__back',
        animationDuration: '700ms',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear',
        position: 'absolute',
        top: 0,
        left: 0,
      },
      '& .smoyPin': { position: 'relative', zIndex: 12, width: 56 },
      '& .smoyBG': {
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: '96px',
        height: '96px',
      },
      '& .bannerContent': {
        margin: '16px 0 0',
        textAlign: 'center',
        '& span': {
          fontWeight: 800,
        },
        '& p': {
          fontSize: '18px',
          lineHeight: '24px',
          color: '#2B1C2F',
          margin: '4px 0',
          fontWeight: 800,
        },
        '& button > span > span': {
          display: 'flex',
          alignItems: 'center',
        },
      },
    },
  },
  [theme.breakpoints.up('md')]: {
    gameBannerContainer: {
      padding: '40px',
      margin: '0 0 40px',
    },
    gameBanner: {
      padding: '16px 32px',
      '& .spinCover': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '256px',
        height: '256px',
        position: 'absolute',
        margin: '0',
      },
      '& .spinBG': {
        width: '256px',
        height: '256px',
        position: 'absolute',
        top: 0,
        left: 0,
      },
      '& .smoyPin': { width: 56 },
      '& .smoyBG': {
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: '112px',
        height: '112px',
      },
      '& .bannerContent': {
        margin: '0 36px 0 266px',
        textAlign: 'center',
        minHeight: '256px',
        '& p': {
          margin: '4px 0',
        },
      },
    },
  },
  [theme.breakpoints.up('lg')]: {
    gameBannerContainer: {
      padding: '40px',
      margin: '0 0 40px',
    },
    gameBanner: {
      padding: '16px 32px',
      '& .spinCover': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '256px',
        height: '256px',
        position: 'absolute',
        margin: '0',
      },
      '& .spinBG': {
        width: '256px',
        height: '256px',
        position: 'absolute',
        top: 0,
        left: 0,
      },
      '& .smoyPin': { width: 56 },
      '& .smoyBG': {
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: '200px',
        height: '200px',
      },
      '& .bannerContent': {
        margin: '0 216px 0 296px',
        textAlign: 'center',
        minHeight: '256px',
        '& p': {
          margin: '4px 0',
        },
      },
    },
  },
}))

const NFTGameBanner = () => {
  const classes = useStyles()
  return (
    <Box className={classes.gameBannerContainer}>
      <Box className={classes.gameBanner}>
        <Box className="spinCover">
          <Box className="spinBG" />
          <img className="smoyPin" src="/images/coins/smoy.png" alt="samoy" />
        </Box>
        <img className="smoyBG" src="/images/samoyed-cheer.svg" alt="samoy" />

        <Box className="bannerContent">
          <TextShadow color="white" size="48" colorBorder="black" sizeBorder="4" lineHeight="60">
            Wheel of Samoyed
          </TextShadow>
          <p>
            Place the Bet.
            <br />
            Trust your Fate.
            <br />
            Spin the Wheel.
            <br />
            Get your SMOY NFT!
            <br />
          </p>
          <HoverButtton>
            <TextShadow color="white" size="48" colorBorder="black" sizeBorder="2" lineHeight="60">
              <img src="/images/icons/play.svg" alt="play" />
              Play Now!
            </TextShadow>
          </HoverButtton>
        </Box>
      </Box>
      {/*
      <Box className={classes.soonBanner}>
          <Box className='textInfo'>
            <h5>Coming Soon!</h5>
            <p></p>
          </Box>
        <img className='imagePreview' src="/images/coming-soon.png" alt="play" />
      </Box>
      */}
    </Box>
  )
}

export default NFTGameBanner
